<template>
  <div
    id="viewPhoto"
    v-loading="floading"
    element-loading-background="transparent"
  >
    <div class="photo-view">
      <section>
        <div class="col-12 px-3" v-if="photoModel != null">
          <a
            class="navigate-target navigate-prev"
            href="javascript:void(0);"
            @click="change(photoModel.previousId)"
            :title="$t('Album.photoview.Lastpage')"
            ><i class="fa fa-chevron-left fa-2x"></i
          ></a>
          <a
            class="navigate-target navigate-next"
            href="javascript:void(0);"
            @click="change(photoModel.nextId)"
            :title="$t('Album.photoview.nextpage')"
            ><i class="fa fa-chevron-right fa-2x"></i
          ></a>
          <div class="photo-view-image">
            <img
              @click="centerDialogVisible = true"
              :src="photoModel.imageUrl_PB"
            />
          </div>
          <el-dialog
            :visible.sync="centerDialogVisible"
            width="75%"
            style="margin-top: -200px"
          >
            <img :src="photoModel.imageUrl_PB" />
          </el-dialog>
          <!-- 下載目錄 -->
          <ul id="download-menu" role="menu" v-if="photoModel != null">
            <li class="dropdown-menu-item">
              <a
                v-if="getDownloadImage(photoModel.downUrl).length >= 1"
                :href="getDownloadImage(photoModel.downUrl)[0]"
                :title="$t('Album.photoview.DownloadHD')"
              >
                <img
                  src="../../assets/images/icons/icon-download-hd-b.png"
                  width="36"
                />
                {{$t('Album.photoview.DownloadHD')}}
              </a>
              <a
                v-if="
                  getDownloadImage(photoModel.downUrl).length === 2 &&
                  getIsShowOrg(photoModel.sgL_CreateTime)
                "
                :title="$t('Album.photoview.Downloadlossless')"
                :href="getDownloadImage(photoModel.downUrl)[1]"
              >
                <img
                  src="../../assets/images/icons/icon-download-full-b.png"
                  width="36"
                />{{$t('Album.photoview.Downloadlossless')}}
              </a>
            </li>
            <!-- <li class="dropdown-menu-item">
              <a
                v-if="
                  photoModel.downUrl != null && photoModel.downUrl.length == 1
                "
                :href="photoModel.downUrl[0]"
                title="下載 (原始無損)"
              >
                <img
                  src="../../assets/images/icons/icon-download-full-b.png"
                  width="36"
                />下載 (原始無損)
              </a>
              <a
                v-if="
                  photoModel.downUrl != null && photoModel.downUrl.length == 2
                "
                :href="photoModel.downUrl[1]"
                title="下載 (原始無損)"
              >
                <img
                  src="../../assets/images/icons/icon-download-full-b.png"
                  width="36"
                />下載 (原始無損)
              </a>
              <a
                v-if="
                  photoModel.downUrl != null && photoModel.downUrl.length == 3
                "
                :href="photoModel.downUrl[2]"
                title="下載 (原始無損)"
              >
                <img
                  src="../../assets/images/icons/icon-download-full-b.png"
                  width="36"
                />下載 (原始無損)
              </a>
            </li> -->
          </ul>
          <!-- /.下載目錄 -->

          <div class="photo-bottom-bar">
            <a
              class="back-to-album-btn"
              href="javascript:void(0);"
              @click="callBack"
              :title="$t('Album.photoview.Returnalbum')"
              ><i class="fa fa-arrow-left fa-fw fa-1x mr-1"></i> {{$t('Album.photoview.Returnalbum')}}
            </a>
            <a
              class="slider-btn"
              href="javascript:void(0);"
              @click="
                dialogStatus ? stopAutoTimers() : autochange(photoModel.nextId)
              "
              :title="$t('Album.photoview.Slideshow')"
              ><i
                :class="
                  dialogStatus
                    ? 'fa fa-stop fa-fw fa-1x mr-1'
                    : 'fa fa-play fa-fw fa-1x mr-1'
                "
              ></i>
            </a>
            <ul class="action">
              <a
                href="javascript:;"
                class="mr-2"
                v-if="
                  photoModel &&
                  loginUser &&
                  photoModel.sgL_Mem_Cid === loginUser.userId
                "
                @click="deleteImage"
                >{{$t('Album.photoview.del')}}</a
              >
              <a
                :title="$t('Album.photoview.good')"
                href="javascript:void(0)"
                @click="
                  addfavorite(
                    photoModel.sgL_PG_Coid,
                    photoModel.sgL_PG_CMasterSort,
                    1,
                    photoModel.id,
                    1
                  )
                "
                ><i class="fas fa-thumbs-up mr-1" v-if="photoModel.isLike"></i
                ><i class="far fa-thumbs-up mr-1" v-else>{{$t('Album.photoview.good')}}</i></a
              >

              <!-- <a class="like" href="">
                <i class="far fa-thumbs-up fa-fw fa-1x mr-1"></i> 讚好
              </a> -->
              <!-- <a class="bookmark ml-4" href="">
                <i class="far fa-bookmark fa-fw fa-1x mr-1"></i> 收藏
              </a> -->
              <a
                class="bookmark ml-4"
                href="javascript:void(0)"
                @click="
                  addfavorite(
                    photoModel.sgL_PG_Coid,
                    photoModel.sgL_PG_CMasterSort,
                    1,
                    photoModel.id,
                    0
                  )
                "
                ><i
                  class="fas fa-bookmark fa-fw"
                  v-if="photoModel.isCollection"
                ></i>
                <i class="far fa-bookmark fa-fw" v-else></i>{{$t('Album.photoview.collect')}}</a
              >
              <a class="share ml-4" href="javascript:;" @click="share">
                <i class="fa fa-share fa-fw fa-1x mr-1"></i> {{$t('Album.photoview.share')}}
              </a>
              <a class="download-btn ml-4" @click="showDownloadMenu()">
                <i class="fa fa-cloud-download-alt fa-fw fa-1x mr-1"></i> {{$t('Album.photoview.Download')}}
              </a>
            </ul>
          </div>
        </div>
      </section>
    </div>
    <div class="photo-content container mt-2">
      <section v-if="photoModel != null">
        <div class="row">
          <div class="col-lg-9 pr-lg-4">
            <div class="card p-4">
              <div class="row">
                <div class="col-12">
                  <h2 class="title mb-1">{{ photoModel.sgL_PG_LPhotoName }}</h2>
                </div>
              </div>
              <div class="subrow row mt-2">
                <div class="col-12">
                  <div class="uploader">
                    <a href="" title="Username">
                      <img
                        class="user-logo mr-1"
                        :src="photoModel.userLogoSmail"
                        :onerror="$defaultUserLog"
                        alt="user-icon"
                      />
                      {{ photoModel.sgL_DisplayName }}
                    </a>
                  </div>
                  <div class="date">{{ photoModel.sgL_PG_CAddTimerI }}</div>
                  <div class="shorten-url">
                    <div class="shorten-url-text inb-1">
                      <i class="fa fa-link fa-fw fa-1x"></i> {{$t('Album.photoview.shortWebUrl')}}
                    </div>
                    <input
                      class="form-control inb-2"
                      type="text"
                      :value="shortWebUrl"
                      readonly
                      onClick="this.select();"
                    />
                    <a
                      href="javascript:;"
                      @click="copyShortLink"
                      style="margin-left: 5px"
                      >{{$t('Album.photoview.copy')}}</a
                    >
                  </div>
                </div>
              </div>
              <div class="tag-line mt-1">
                <!-- 關鍵字：<a
                    class="tag"
                    href=""
                    v-for="keyword in album.sgL_PG_LPhotoKeyArray"
                    :key="keyword"
                    >{{ keyword }}</a
                  > -->
              </div>
              <div>
                <hr class="divider" />
                <userCommentsVue
                  ref="comment"
                  @submitComment="submitComment"
                  @submitComment2="submitComment2"
                  @allCommentCount="allCommentCount"
                ></userCommentsVue>
              </div>
              <!-- <hr class="divider" />
              (這裡放 Facebook 留言插件)
              <a href="https://developers.facebook.com/docs/plugins/comments/"
                >https://developers.facebook.com/docs/plugins/comments/</a
              > -->
            </div>
          </div>
          <div class="col-lg-3">
            <div class="ad section-group">
              <div class="row">
                <div class="col-12">
                  <ins
                    class="adsbygoogle"
                    style="display: inline-block; width: 300px; height: 250px"
                    data-ad-client="ca-pub-8370308321819212"
                    data-ad-slot="7350126089"
                  ></ins>
                </div>
              </div>
            </div>
            <div class="card p-4">
              <ul class="photo-stat">
                <div class="row">
                  <li class="col-4">
                    <span> {{ photoModel.sgL_PG_Hits }} </span><br />
                    {{$t('Album.photoview.view')}}
                  </li>
                  <li class="col-4">
                    <span> {{ photoModel.sgL_PG_Favorite }} </span><br />
                    {{$t('Album.photoview.collect')}}
                  </li>
                  <li class="col-4">
                    <span> {{ photoModel.sgL_PG_Message }} </span><br />
                    {{$t('Album.photoview.leaveword')}}
                  </li>
                </div>
              </ul>
              <hr class="divider" />
              <div class="exif-list" v-if="photoModel.photoDtl != null">
                <li>
                  <span class="exif-name">{{$t('Album.photoview.Cameramanufacturer')}}</span>
                  <span class="exif-value">{{
                    photoModel.photoDtl.ex_Camera_maker
                  }}</span>
                </li>
                <li>
                  <span class="exif-name">{{$t('Album.photoview.Cameratype')}}</span>
                  <span class="exif-value">{{
                    photoModel.photoDtl.ex_Camera_model
                  }}</span>
                </li>
                <li>
                  <span class="exif-name">{{$t('Album.photoview.size')}}</span>
                  <span class="exif-value"
                    >{{ photoModel.photoDtl.ex_Dimensions }}‬</span
                  >
                </li>
                <li>
                  <span class="exif-name">{{$t('Album.photoview.Dateshooting')}}</span>
                  <span class="exif-value"
                    >{{ photoModel.photoDtl.ex_Date_taken }}‬</span
                  >
                </li>
                <div
                  v-if="photoModel.sgL_PG_LPhotoExif"
                  class="show-extended-exif"
                  @click="pictureInfoshow = !pictureInfoshow"
                >
                  <i class="fa fa-plus fa-fw"></i> EXIF
                </div>
                <ul id="extended-exif" v-show="pictureInfoshow">
                  <li class="extended-exif-item">
                    <span class="exif-name">{{$t('Album.photoview.aperture')}}</span>
                    <span class="exif-value">{{
                      photoModel.photoDtl.ex_F_stop
                    }}</span>
                  </li>
                  <li class="extended-exif-item">
                    <span class="exif-name">{{$t('Album.photoview.exposure')}}</span>
                    <span class="exif-value">{{
                      photoModel.photoDtl.ex_Exposure_time
                    }}</span>
                  </li>
                  <li class="extended-exif-item">
                    <span class="exif-name">{{$t('Album.photoview.Focallength')}}</span>
                    <span class="exif-value">{{
                      photoModel.photoDtl.ex_Focal_length
                    }}</span>
                  </li>
                  <li class="extended-exif-item">
                    <span class="exif-name">{{$t('Album.photoview.Luminancevalue')}}</span>
                    <!-- <span class="exif-value">{{photoModel.photoDtl.}}</span> -->
                  </li>
                  <li class="extended-exif-item">
                    <span class="exif-name">{{$t('Album.photoview.Exposurecompensation')}}</span>
                    <span class="exif-value">{{
                      photoModel.photoDtl.ex_Exposure_bias
                    }}</span>
                  </li>
                  <li class="extended-exif-item">
                    <span class="exif-name">{{$t('Album.photoview.sensitivity')}}</span>
                    <span class="exif-value">{{
                      photoModel.photoDtl.ex_ISO_speed
                    }}</span>
                  </li>
                  <li class="extended-exif-item">
                    <span class="exif-name">{{$t('Album.photoview.flashlight')}}</span>
                    <span class="exif-value">{{
                      photoModel.photoDtl.ex_Flash_mode
                    }}</span>
                  </li>
                  <li class="extended-exif-item">
                    <span class="exif-name">{{$t('Album.photoview.Exposureprogram')}}</span>
                    <!-- <span class="exif-value">{{photoModel.photoDtl.}}</span> -->
                  </li>
                  <li class="extended-exif-item">
                    <span class="exif-name">{{$t('Album.photoview.Photometricmode')}}</span>
                    <span class="exif-value">{{
                      photoModel.photoDtl.ex_Metering_mode
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    
      <shareVue ref="shareVue"></shareVue>
  </div>
</template>
<script>
import userCommentsVue from "../common/userComments.vue";
import base from "../../api/httpApi/base";

import shareVue from '../common/share.vue';
export default {
  data() {
    return {
      photoModel: null,
      imageId: null,
      Coid: null,
      // SPID: null,
      // SPKEY: null,
      centerDialogVisible: false,
      floading: true,
      pictureInfoshow: false,
      shortWebUrl: null,
      nextModel: null,
      previousModel: null,
      autochangeTime: null,
      dialogStatus: false,
      commentsParams: null,
      currentPage: null,
    };
  },
  components: {
    userCommentsVue,
        shareVue
  },
  created() {
    this.stopAutoTimers();
    //this.shortWebUrl = location.href;
    this.$store.dispatch("updateCurrentIndex", 4);
    this.imageId = this.$route.query.Liid;
    this.Coid = this.$route.query.Coid;
    // this.SPID = this.$route.query.SPId;
    // this.SPKEY = this.$route.query.title;
    this.shortWebUrl = `${base.evi}/V${this.Coid}-${this.imageId}`;
    if (this.$route.query.currentPage) {
      this.currentPage = this.$route.query.currentPage;
    }
    this.GetPhotoDtl();
  },
  methods: {
    getBeforeDate(n) {
      var date = new Date();
      var year, month, day;
      date.setDate(date.getDate() - n);
      year = date.getFullYear();
      month = date.getMonth() + 1;
      day = date.getDate();
      let s =
        year +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (day < 10 ? "0" + day : day);
      return s;
    },
    getIsShowOrg(dt) {
      if (!dt) {
        return false;
      }
      const a = dt.replace("T", " ");
      const b = this.getBeforeDate(365);
      if (new Date(a) >= new Date(b)) {
        return true;
      } else {
        return false;
      }
    },
    getDownloadImage(arr) {
      if (!arr || arr.length === 0) {
        return [];
      }
      if (arr.length === 1 || arr.length === 2) {
        return arr;
      }
      return [...arr.slice(arr.length - 2)];
    },
    deleteImage() {
      if (this.photoModel) {
        let params = {
          Id: this.photoModel.id,
        };
        this.$api.albumApi.delphoto(params).then((res) => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: this.$t('message.operatesuccessfully'),
            });
            if (this.photoModel.nextId) {
              this.change(this.photoModel.nextId);
            } else {
              if (this.photoModel.previousId) {
                this.change(this.photoModel.previousId);
              }
            }
          }
        });
      }
    },
    copyShortLink() {
      this.copyToClipboard(this.shortWebUrl, true);
    },
    share () {
      // let urlb = escape(`/Home/facebookResp?id=${this.imageId}&type=photoview`);
      //console.log(1111111111, `${vue.$shareUrl}${bases.url}${urlb}`);
      // window.open(`${this.$shareUrl}${base.url}${urlb}`, "_blank");
      this.$refs.shareVue.setWinData(this.imageId, "photoview");
    },
    callBack() {
      this.$router.go(-1);
    },
    initComment() {
      this.commentsParams = {
        SGL_PG_Coid: this.Coid,
        SGL_Msg_Belongidc: this.imageId,
        SGL_Msg_Type: 1,
      };
      this.$refs.comment.getComments(false, this.commentsParams);
    },
    allCommentCount(data) {
      if (this.photoModel != null) {
        this.photoModel.sgL_PG_Message = data;
      }
    },
    submitComment(data) {
      let params = {
        sgL_PG_CBigsort: this.photoModel.sgL_PG_CMasterSort,
        SGL_Msg_Belongidc: this.imageId,
        sgL_PG_Coid: this.Coid,
        sgL_Msg_Type: 1,
        sgL_Msg_MContent: data,
        sgL_Msg_SendType: 0,
        SGL_Mem_FinallyReceive_Cid: this.photoModel.sgL_Mem_Cid,
      };
      this.$refs.comment.submit(params, this.commentsParams);
    },
    submitComment2(
      data,
      sgL_Msg_ReplyMsgid,
      sgL_Mem_FinallyReceive_Cid,
      sgL_Mem_Reply_Cid
    ) {
      let params = {
        sgL_PG_CBigsort: this.photoModel.sgL_PG_CMasterSort,
        SGL_Msg_Belongidc: this.imageId,
        sgL_PG_Coid: this.Coid,
        sgL_Msg_Type: 1,
        sgL_Msg_MContent: data,
        sgL_Msg_ReplyMsgid: sgL_Msg_ReplyMsgid,
        sgL_Mem_FinallyReceive_Cid: sgL_Mem_FinallyReceive_Cid,
        sgL_Mem_Reply_Cid: sgL_Mem_Reply_Cid,
        sgL_Msg_SendType: 1,
      };
      this.$refs.comment.submit(params);
    },
    GetPhotoDtl() {
      let params = {
        Coid: this.Coid,
        Liid: this.imageId,
        // SGL_PhotoCollectionId: this.SPID,
        // SGL_PG_LPhotoKey: this.SPKEY,
      };
      this.$api.albumApi
        .GetPhotoDtl(params)
        .then((res) => {
          if (res.data.success) {
            this.floading = false;
            this.photoModel = res.data.result;
            let nextparams = {
              Coid: this.Coid,
              Liid: this.photoModel.nextId,
            };
            this.$api.albumApi.GetPhotoDtl(nextparams).then((next) => {
              if (next.data.success) {
                this.nextModel = next.data.result;
              }
            });
            let preparams = {
              Coid: this.Coid,
              Liid: this.photoModel.previousId,
            };
            if (preparams.Liid) {
              this.$api.albumApi.GetPhotoDtl(preparams).then((pre) => {
                if (pre.data.success) {
                  this.previousModel = pre.data.result;
                }
              });
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.error.message,
            });
            if (res.data.error.code === 404 || res.data.error.code === 0) {
              setTimeout(() => {
                this.$router.go(-1);
              }, 2000);
            }
          }
        })
        .then(() => {
          this.initComment();
        });
    },
    addfavorite(tid, type, Ftype, longid, DevicesType) {
      let params = {
        sgL_DevicesType: DevicesType,
        sgL_MasterSort: type, //类型
        sgL_PG_Coid: tid, //图册、影片、文章、活动的id
        sgL_Fav_FType: Ftype, //图册：0，图片：1，影片：2,文章：4，活动：3
        sgL_Fav_FBelongidc: longid, //图片id
      };
      this.$store.dispatch("addfavorite", params).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
          if (DevicesType === 0) {
            this.photoModel.isCollection = !this.photoModel.isCollection;
          } else if (DevicesType === 1) {
            this.photoModel.isLike = !this.photoModel.isLike;
          }
          //this.GetPhotoDtl();
          // if (Ftype == 0) {
          //   this.getPicturePublish();
          // } else if (Ftype == 2) {
          //   this.getVideoPublish();
          // }
        }
      });
    },
    showDownloadMenu() {
      var x = document.getElementById("download-menu");
      if (x.style.display === "block") {
        x.style.display = "none";
      } else {
        x.style.display = "block";
      }
    },

    showExif() {
      var x = document.getElementById("extended-exif");
      if (x.style.display === "none") {
        x.style.display = "block";
      } else {
        x.style.display = "none";
      }
    },
    change(id) {
      if (id != null) {
        if (this.nextModel != null && this.nextModel.id == id) {
          this.photoModel = this.nextModel;
        } else {
          this.photoModel = this.previousModel;
        }
        this.imageId = id;
        this.GetPhotoDtl();
      }
    },
    autochange(id) {
      this.dialogStatus = true;
      let _this = this;
      _this.change(_this.photoModel.nextId);
      if (id != null) {
        this.autochangeTime = setInterval(function () {
          _this.change(_this.photoModel.nextId);
        }, 3000);
      } else {
        if (this.autochangeTime != null) {
          this.stopAutoTimers();
        }
      }
    },
    stopAutoTimers() {
      this.dialogStatus = false;
      clearInterval(this.autochangeTime);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Album/photoview.vue